import { RowDataMerchandise } from "../../components/MerchandisePage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the MerchandiseTable factory
 */
class MerchandiseRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/merchandise/read-range"
        this.accessData = "merchandises"
    }

    create(merchandise: any): RowDataMerchandise {
        const rowDataMerchandise: RowDataMerchandise = {
            id: merchandise.id,
            merchandiseName: merchandise.merch_name,
            merchandiseModel: merchandise.merch_model,
            merchandiseDesc: merchandise.merch_desc,
            imageSrc: merchandise.merch_img,
            quantity: merchandise.quantity,
            cost: merchandise.cost,
            action: "",
        };
        return rowDataMerchandise;
    }

    generateParams(params: any, extra: any): any {
        params["uid"] = extra.uid
        params["current"] = extra.current
        return params
    }
}

let merchandiseRow: MerchandiseRow | null = null;

export default function getMerchandiseRow(): MerchandiseRow {
    if (merchandiseRow === null)
        merchandiseRow = new MerchandiseRow()
    return merchandiseRow
}